import {ToastModel} from '@syncfusion/ej2-notifications';

export class ToastInfoModel implements ToastModel {
  readonly cssClass = 'is-info';
  icon = 'icon-zap';
  title = '';

  constructor(public content: string, title?: string, iconCss?: string) {
    if (iconCss) {
      this.icon = iconCss;
    }

    if (title) {
      this.title = title;
    }
  }
}
